






import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { getBaseInfo } from './api';

const baseUrl = 'HLSQZDY0721';

@Component
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动主页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '活动简介',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    var cover =
      'https://image2.cqcb.com/d/file/image/default/2023-07-21/4b832bf2e33e353774eb27f27750d2b3.jpeg';

    if (this.$route.path.indexOf('rule') > -1) {
      cover =
        'https://image2.cqcb.com/d/file/image/default/2023-07-27/696ab7633d167e862c836135947f0c3d.jpeg';
    }

    // App分享
    this.$appShareInfo({
      title: '“欢乐社区总动员”首届水上趣味篮球赛最佳人气战队投票通道',
      url: location.href,
      subtitle: `快来为“水BA”战队投票吧！`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '“欢乐社区总动员”首届水上趣味篮球赛最佳人气战队投票通道',
        subtitle: `快来为“水BA”战队投票吧！`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    console.log('RET:::', ret);
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
